angular.module('rjmNg.directives').directive "sqlInterface", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlInterface.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: true
    controller: [
      "app"
      "sql"
      "$rootScope"
      "figureService"
      "reportQueryType"
      "$routeParams"
      "Figures"
      "logger"
      "$location"
      "queryStatus"
      "appRoute"
      (
        app
        sql
        $rootScope
        figureService
        reportQueryType
        $routeParams
        Figures
        logger
        $location
        queryStatus
        appRoute
      ) ->

        view = @
        view.queryStatus = queryStatus
        view.previousResult = null
        view.isLoading = false

        figureId = $routeParams.figureId
        dashboard = if $routeParams.dashboardId? then app.getDashboard($routeParams.dashboardId) else null

        _getDefaultHighcharts = () ->
          return
            chart:
              type: 'line'

        _getEmptyFigure = () ->
          return
            query:
              sql: ''
            name: ''
            presentationType:
              id: 2
            presentationVersion: 0.1
            description: ''
            presentation:
              highcharts: _getDefaultHighcharts()
            state:
              id: 1
            reportQueryType: reportQueryType.SQL

        _getPresentationFromFigureOrDefault = (figure) ->
          # Fill in any missing presentation namespaces
          if not figure.presentation.highcharts?
            return  _getDefaultHighcharts()

          return figure.presentation

        unless app.canAccessSqlReportBuilder()
          $location.path appRoute("/")

        if not figureId?
          view.currentFigure = _getEmptyFigure()
          logger.log("SQL Report Builder Usage", "Open", 1, "create")
        else
          requestOptions = Figures.getRequestOptions(false, true)
          Figures.get(figureId, false, requestOptions).then( (figure) ->
              view.currentFigure = figure
              view.currentFigure.presentation = _getPresentationFromFigureOrDefault(view.currentFigure)
              view.editor?.setValue(figure.query.sql)
          )
          logger.log("SQL Report Builder Usage", "Open", 1, "edit")

        view.runSqlQuery = () ->
          view.isLoading = true
          view.message = "Running query..."
          sql.run(view.editor.getValue())
          .then( (result) ->
            response = result.data
            view.previousResult = result
            if response.data.error?
              view.message = "Error processing query"
              view.status = queryStatus.ERROR
              $rootScope.$broadcast 'updateResult', result
            else
              s = if response.data.body.length > 1 then 's' else ''
              view.message = "#{response.data.body.length} Row#{s} in #{response.data.executionTime.toFixed(4)} seconds."
              view.status = queryStatus.SUCCESS
              view.currentFigure.data = result.data.data

            view.redraw(result)

            view.currentFigure.query =
              sql: view.editor.getValue()

            view.isloading = false
          , (error) ->
            view.message = error
            view.status = queryStatus.ERROR
            view.isLoading = false
          )

        view.redraw = (result) ->
          # So we can redraw without running a new query
          unless result?
            if not view.previousResult
              return
            result = view.previousResult

          result.data.presentation = _getPresentationFromFigureOrDefault(view.currentFigure)
          $rootScope.$broadcast 'updateResult', result

        view.setType = (type) ->
          view.currentFigure = figureService.setChartType(view.currentFigure, type)
          view.redraw()

        view.addCategory = (name) ->
          view.currentFigure = figureService.addCategory(view.currentFigure, name)
          view.redraw()

        view.removeCategory = (name) ->
          view.currentFigure = figureService.removeCategory(view.currentFigure, name)
          view.redraw()

        view.setCategories = (names) ->
          view.currentFigure = figureService.setCategories(view.currentFigure, names)
          view.redraw()

        view.addSeries = (name) ->
          view.currentFigure = figureService.addSeries(view.currentFigure, name)
          view.redraw()

        view.removeSeries = (name) ->
          view.currentFigure = figureService.removeSeries(view.currentFigure, name)
          view.redraw()

        view.setSeries = (names) ->
          view.currentFigure = figureService.setSeries(view.currentFigure, names)
          view.redraw()

        view.addLabel = (name) ->
          view.currentFigure = figureService.addLabel(view.currentFigure, name)
          view.redraw()

        view.removeLabel = (name) ->
          view.currentFigure = figureService.removeLabel(view.currentFigure, name)
          view.redraw()

        view
    ]
    link: (scope, elem, attrs) ->

      scope.$on 'runSqlQuery', scope.view.runSqlQuery

      scope.$on 'redrawSQLResult', () ->
        scope.view.redraw()

      scope.$on 'setChartType', (event, type) ->
        scope.view.setType(type)

      scope.$on 'addCategory', (event, name) ->
        scope.view.addCategory(name)

      scope.$on 'removeCategory', (event, name) ->
        scope.view.removeCategory(name)

      scope.$on 'setSeries', (event, names) ->
        scope.view.setSeries(names)

      scope.$on 'addSeries', (event, name) ->
        scope.view.addSeries(name)

      scope.$on 'removeSeries', (event, name) ->
        scope.view.removeSeries(name)

      scope.$on 'addLabel', (event, name) ->
        scope.view.addLabel(name)

      scope.$on 'removeLabel', (event, name) ->
        scope.view.removeLabel(name)

      scope.$watch 'view.editor', (editor) ->
        if editor? and scope.view.currentFigure?
          editor.setValue(scope.view.currentFigure.query.sql)

      scope.view.message = "Ready to Query"
      scope.view.status = scope.view.queryStatus.SUCCESS
      scope.view.buttonName = "Run Query"
]
